import React from 'react';
import { clearRegForm, doLogout } from 'actions';
import { GUEST } from 'Enums/middleware';
import Link from 'components/Link';
import SignUpCard from 'components/Register/_components/SignUpCard';
import { APP_CONFIG } from '../../Config';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './styles.scss';

const bidder = '/static/images/registration-icons/bidder.svg';
const facilityManager = '/static/images/registration-icons/facility-manager.svg';
const privateSeller = '/static/images/registration-icons/private-seller.svg';
const charityLogo = '/static/images/charity-logo.png';
const LegalServiceLocatorLogo = '/static/images/legal-notice-locator-logo.png';

const { REACT_APP_ENABLE_PRIVATE_SELLERS } = APP_CONFIG;

const Register = () => {
    return (
        <div className="register marginB15">
            <h3 className="font-weight-bold">Select an Account Type:</h3>
            <Row className="text-center justify-content-center">
                <Col md={12} lg={4}>
                    <SignUpCard
                        title="Auction Buyer"
                        img={bidder}
                        listItems={[
                            'Browse onsite storage auctions',
                            'View & bid on storage units online',
                            'Learn the buying & reselling biz',
                            'Weekly auction update emails!',
                        ]}
                        to="/register/auction-buyer"
                        buttonText="Sign Up as a Buyer"
                    />
                </Col>
                <Col md={12} lg={4}>
                    <SignUpCard
                        title="Facility Manager"
                        img={facilityManager}
                        listItems={[
                            'Advertise onsite or post online auctions',
                            'Promote auctions to 1Mil+ buyers',
                            'Custom Facility Homepage with auctions',
                            'Access Self Storage Legal Network',
                        ]}
                        to="/register/facility-manager"
                        buttonText="Sign Up as a Manager"
                    />
                </Col>
                {REACT_APP_ENABLE_PRIVATE_SELLERS &&
                    <Col md={12} lg={4}>
                        <SignUpCard
                            title="Private Seller"
                            img={privateSeller}
                            listItems={[
                                'Post and sell items from a storage unit',
                                'Promote your items to 1Mil+ buyers',
                            ]}
                            to="/register/private-seller"
                            buttonText="Sign Up as a Private Seller"
                        />
                    </Col>
                }
            </Row>
            <Row>
                <div className="orange-bar text-center">
                    <h4 className="font-weight-bolder text-white">
                        Includes FREE access to our partner sites:
                    </h4>
                </div>
            </Row>
            <Row className="mt-5 small">
                <Col md={6}>
                    <div className="text-center logo-container">
                        <a href="https://charitystorage.org/" target="_blank" rel="noopener noreferrer">
                            <img src={charityLogo} className="logo" alt="Charity storage" />
                        </a>
                    </div>
                    <p>
                        Charity Storage utilizes self storage auctions to raise money for charities nationwide.
                        Ask your facilities to designate a unit to serve as a donation drop off point.
                        Then facilities can invite the community, departing tenants, and auction buyers to donate
                        items to the unit. Auction the unit at your next auction & all the money goes to charity.
                        The donors get a tax receipt so they can deduct their donation & you'll get recognized
                        for your involvement on {' '}
                        <a href="https://charitystorage.org/" target="_blank" rel="noopener noreferrer">
                            CharityStorage.org
                        </a>
                        {' '}& <Link to="/" target="_blank">StorageTreasures.com</Link>.
                    </p>
                </Col>
                <Col md={6}>
                    <div className="text-center logo-container">
                        <a href="http://legalnoticelocator.com/public_auctions/" target="_blank" rel="noopener noreferrer">
                            <img src={LegalServiceLocatorLogo} className="logo" alt="Legal notice locator" />
                        </a>
                    </div>
                    <p>
                        Legal Notice Locator is a new site that advertises legal notices to a larger audience than the newspapers could ever reach. Publish your auction notices here to help combat newspaper lobbyist
                        that drive up auction expenses for the storage industry. Let's show our legislators that we can reach more people online without expensive newspaper ads!
                    </p>
                </Col>
            </Row>
        </div>
    );
};

Register.getInitialProps = async ({ store: { dispatch } }) => {
    await Promise.all([
        dispatch(clearRegForm()),
        dispatch(doLogout()),
    ]);

    const pageData = {
        title: 'Account Registration',
        h1: 'Create an Account',
        marginBottom: 'pageTitle marginB20',
        description: undefined,
    };

    return { pageData };
};

Register.middleware = GUEST;
Register.middleware_redirect = '/account/dashboard';

export default Register;